import { render, staticRenderFns } from "./PageBackground.vue?vue&type=template&id=54f371b9&scoped=true&"
import script from "./PageBackground.vue?vue&type=script&lang=js&"
export * from "./PageBackground.vue?vue&type=script&lang=js&"
import style0 from "./PageBackground.vue?vue&type=style&index=0&id=54f371b9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f371b9",
  null
  
)

export default component.exports